import React, { Component } from "react";

import starImg from "../../images/star.svg";

class AddressBody extends Component {
  render() {
    var addressLine = this.props.data.Address1;

    if (this.props.data.Address2) {
      addressLine += ", " + this.props.data.Address2;
    }

    if (this.props.data.Address3) {
      addressLine += ", " + this.props.data.Address3;
    }

    let specialMark = undefined;
    let showStar = false;

    if (this.props.data.Primary && this.props.data.Mailing) {
      specialMark = "Primary & Mailing Address";
      showStar = true;
    } else if (this.props.data.Primary) {
      specialMark = "Primary Address";
      showStar = true;
    } else if (this.props.data.Mailing) {
      specialMark = "Mailing Address";
    } else {
      specialMark = "Other Address";
    }

    let addressLine2 = "";

    if (this.props.data.City) {
      addressLine2 += this.props.data.City;
    }

    if (this.props.data.State) {
      if (addressLine2 !== "") {
        addressLine2 += ", ";
      }
      addressLine2 += this.props.data.State;
    }

    if (this.props.data.ZipCode) {
      if (addressLine2 !== "") {
        addressLine2 += " ";
      }

      addressLine2 += this.props.data.ZipCode;
    }

    if (addressLine2 === "") {
      addressLine2 = undefined;
    }

    return (
      <div>
        <div className="primary-obj">
          {showStar && <img alt="primary" src={starImg} />}
          <span>{specialMark}</span>
        </div>
        <div className="data-line">
          <span className="value-data">{addressLine}</span>
        </div>
        {addressLine2 && (
          <div className="data-line">
            <span className="value-data">{addressLine2}</span>
          </div>
        )}
      </div>
    );
  }
}

export default AddressBody;
